import { render, staticRenderFns } from "./goods-message.vue?vue&type=template&id=53752cc8&scoped=true"
import script from "./goods-message.vue?vue&type=script&lang=js"
export * from "./goods-message.vue?vue&type=script&lang=js"
import style0 from "./goods-message.vue?vue&type=style&index=0&id=53752cc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53752cc8",
  null
  
)

export default component.exports